const OWL = "http://www.w3.org/2002/07/owl#";
const XOWL = "https://graphifi.com/schema/xowl/";
const RDFS = "http://www.w3.org/2000/01/rdf-schema#";

export const OWL_OBJECT_CONFIGURATION = {
  "domain": {
    "displayName": "Domain",
    "colour": "#212121",
    "iri": RDFS + "domain"
  },
  "disjointWith": {
    "displayName": "Disjoint With",
    "colour": "#212121",
    "stroke-dasharray": "5,5",
    "iri": OWL + "disjointWith"
  },
  "equivalentClass": {
    "displayName": "Equivalent Class",
    "colour": "#212121",
    "iri": OWL + "equivalentClass"
  },
  "hasSubClass": {
    "displayName": "Has Subclass",
    "colour": "#212121",
    "stroke-dasharray": "3,3",
    "iri": XOWL + "hasSubClass"
  },
  "hasSubProperty": {
    "displayName": "Has Subproperty",
    "colour": "#212121",
    "stroke-dasharray": "3,3",
    "iri": XOWL + "hasSubProperty"
  },
  "inverseOf": {
    "displayName": "Inverse Of",
    "colour": "#212121",
    "iri": OWL + "disjointWith"
  },
  "isDefinedBy": {
    "displayName": "Is Defined By",
    "colour": "#212121",
    "iri": RDFS + "isDefinedBy"
  },
  "range": {
    "displayName": "Range",
    "colour": "#212121",
    "iri": RDFS + "range"
  },
  "subClassOf": {
    "displayName": "Subclass Of",
    "colour": "#212121",
    "stroke-dasharray": "3,3",
    "iri": RDFS + "subClassOf"
  },
  "subPropertyOf": {
    "displayName": "Subproperty Of",
    "colour": "#212121",
    "stroke-dasharray": "3,3",
    "iri": OWL + "subPropertyOf"
  }
};

export const VIZ_CLASSES = {
  "Class": {
  },
  "Ontology": {
  }
};

export const MAX_CLASSNAME_LENGTH = 250;
export const MAX_LITERAL_LENGTH = 500;
export const MAX_ONTOLOGY_TITLE_LENGTH = 100;
export const MAX_ONTOLOGY_DESC_LENGTH = 500;

export const ALIAS_LABELS = {
  "OwlClass": "Class",
  "ObjectProperty": "Object property",
  "DatatypeProperty": "Datatype property",
  "AnnotationProperty": "Annotation property",
  "NamedIndividual": "Named Individual",
  "RdfsDatatype": "Datatype"
};
